import {TAB_NAMES} from "../../components/ToolBarTabs";
import {InfoPage} from "../InfoPage";
import {CurrentConfigurationPage} from "../CurrentConfigurationPage";
import {ConfigurationHistoryPage} from "../ConfigurationHistoryPage";
import {UpdatingConfigurationPage} from "../UpdatingConfigurationPage";
import {EditConfigurationPage} from "../EditConfigurationPage";
import * as React from "react";
import {PAGES} from "./index";

export const renderPage = (page: PAGES,
                           tab: TAB_NAMES,
                           hasPermissionsToSeeSettings: boolean,
                           hasPermissionsToEditSettings: boolean,
                           isRWSupported: boolean) => {
    if (!canSeePage(page, hasPermissionsToSeeSettings, hasPermissionsToEditSettings, isRWSupported)) {
        return null;
    }
    switch (page) {
        case PAGES.INFO:
            return <InfoPage/>;
        case PAGES.SETTINGS:
            return (
                <>
                    {tab === TAB_NAMES.CURRENT && <CurrentConfigurationPage/>}
                    {tab === TAB_NAMES.HISTORY && <ConfigurationHistoryPage/>}
                </>
            );
        case PAGES.UPDATING:
            return (
                <>
                    {tab === TAB_NAMES.CURRENT && <UpdatingConfigurationPage/>}
                    {tab === TAB_NAMES.HISTORY && <ConfigurationHistoryPage/>}
                </>
            );
        case PAGES.EDITING:
            return <EditConfigurationPage/>;
        default:
            return null;
    }
};


export const canSeePage = (page: PAGES,
                           hasPermissionsToSeeSettings: boolean,
                           hasPermissionsToEditSettings: boolean,
                           isRWSupported: boolean) => {

    switch (page) {
        case PAGES.SETTINGS:
            return hasPermissionsToSeeSettings && isRWSupported;
        case PAGES.INFO:
            return true;
        case PAGES.UPDATING:
            return hasPermissionsToSeeSettings && isRWSupported;
        case PAGES.EDITING:
            return hasPermissionsToEditSettings && isRWSupported;
        default:
            return false;
    }
}